import { render, staticRenderFns } from "./article-grid.vue?vue&type=template&id=3bb0bb83"
import script from "./article-grid.vue?vue&type=script&lang=js"
export * from "./article-grid.vue?vue&type=script&lang=js"
import style0 from "./article-grid.vue?vue&type=style&index=0&id=3bb0bb83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports